export default __webpack_public_path__ + "static/media/redsalud.6d1bbcea.svg";